import { useState, useEffect } from "react";
import axios from "axios";
import { Apiurl } from "../../../shared/services/apirest";
import { getAuthHeader } from "../utils/investigadorUtils";

export const useProyectos = (showToast, activeProjectId, setActiveProjectId) => {
    const [proyectos, setProyectos] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchProyectos = async () => {
        try {
            const res = await axios.get(`${Apiurl}casos/proyectos/`, getAuthHeader());
            setProyectos(res.data);
        } catch (err) {
            console.error("Error cargando proyectos:", err);
            showToast("Error al cargar proyectos.", "danger");
        } finally {
            setLoading(false);
        }
    };

    const deleteProject = async (id) => {
        await axios.delete(`${Apiurl}casos/proyectos/${id}/`, getAuthHeader());
        setProyectos(prev => prev.filter(p => p.id !== id));
        if (activeProjectId === id) {
            setActiveProjectId(null);
            localStorage.removeItem("activeProjectId");
        }
    };

    const saveProject = async (data, editingProject) => {
        try {
            if (editingProject) {
                await axios.put(`${Apiurl}casos/proyectos/${editingProject.id}/`, data, getAuthHeader());
            } else {
                const res = await axios.post(`${Apiurl}casos/proyectos/`, data, getAuthHeader());
                if (proyectos.length === 0 || !activeProjectId) {
                    setActiveProjectId(res.data.id);
                }
            }
        } catch (err) {
            console.error("Error saving project:", err.response?.data || err);
            let errorMsg = "Error al guardar el proyecto. Verifique los datos.";

            if (err.response?.status === 401) {
                errorMsg = "Sesión expirada o inválida. Por favor, inicie sesión de nuevo.";
            } else if (err.response?.data?.codigo) {
                errorMsg = "El código del proyecto ya está en uso.";
            } else if (err.response?.data?.detail) {
                errorMsg = err.response.data.detail;
            }

            showToast(errorMsg, "danger");
            throw err;
        }
        await fetchProyectos();
    };

    useEffect(() => {
        fetchProyectos();
    }, []);

    return { proyectos, loading, fetchProyectos, deleteProject, saveProject };
};
